<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <pr-input-select-template
                formControlName="rachatPartielType"
                [options]="options"
              >
                <ng-template #optionTemplate let-option let-id="index">
                  <div>
                    <div>
                      <residence-box
                        [suffix]="option.suffix"
                        [title]="option.label"
                      ></residence-box>
                    </div>
                  </div>
                </ng-template>
              </pr-input-select-template>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
